module.exports = __webpack_public_path__ + "9445bc77cd877ccb390dee5d92c28993.png";